export var UploadEvent = {
  Upload: 'upload'
};